import React from 'react'
function ViewEquipment({ item, data, open, onCancel }) {
  const displayItem = item || data;
  return (
    <div className=" w-full h-auto grid grid-cols-1  md:grid-cols-3">
 
      <div className='my-2'>
        <p className='text-[13px] font-medium text-mainColor-400 py-1'> Item</p>
        <p className='text-xs text-mainColor-400'>{displayItem?.item || "-"}</p>
      </div>
      <div className='my-2'>
        <p className='text-[13px] font-medium text-mainColor-400 py-1'>Unit</p>
        <p className='text-xs text-mainColor-400'>{displayItem?.unit || "-"}</p>
      </div>
      <div className='my-2'>
        <p className='text-[13px] font-medium text-mainColor-400 py-1'>Type</p>
        <p className='text-xs text-mainColor-400'>{displayItem?.type}</p>
      </div>

      <div className='my-2'>
        <p className='text-[13px] font-medium text-mainColor-400 py-1'> Quantity</p>
        <p className='text-xs text-mainColor-400'>{displayItem?.quantity || "-"}</p>
      </div>
      <div className='my-2'>
        <p className='text-[13px] font-medium text-mainColor-400 py-1'>UnitPrice</p>
        <p className='text-xs text-mainColor-400'>{displayItem?.unitPrice || "-"}</p>
      </div>
      <div className='my-2'>
        <p className='text-[13px] font-medium text-mainColor-400 py-1'>TotalPrice</p>
        <p className='text-xs text-mainColor-400'>{displayItem?.totalPrice || "-"}</p>
      </div>
      {/* <div className='my-2'>
        <p className='text-[13px] font-medium text-mainColor-400 py-1'>Comments</p>
        <p className='text-xs text-mainColor-400'>{displayItem?.comments || "-"}</p>
      </div> */}
      
    </div>
  )
}

export default ViewEquipment